export default __webpack_public_path__ + "static/media/presentation.6ad04435.png";